import React from 'react';
import { useTranslation } from 'react-i18next';
import { TInvoiceStatus } from '@qapline/core';
import { ExtendedCheckboxField } from '@qapline/ui';

import { FormSection } from '../../../FormSection';
import { PaidState } from '../PaidState';
import { StornoInvoiceButton } from './StornoInvoiceButton';

import styles from './InvoiceStates.module.scss';

export interface IInvoiceStatesProps {
    invoiceId?: number;
    status?: TInvoiceStatus;
}

export const InvoiceStates: React.FC<IInvoiceStatesProps> = ({ invoiceId, status }) => {
    const { t } = useTranslation();
    return (
        <FormSection title={t('invoicing.form.status.sectionTitle')}>
            <div className={styles.statesWrapper}>
                {invoiceId != null && status != null && <StornoInvoiceButton invoiceId={invoiceId} status={status} />}
                <ExtendedCheckboxField name="exported" label={t('invoicing.form.invoiceStatus.exported')} />
                <PaidState />
            </div>
        </FormSection>
    );
};
